module.exports = __webpack_public_path__ + "img/weishengjian.3f896a6e.png";